import {createSlice} from '@reduxjs/toolkit'
import hit from 'src/services/manager'

const initialState={
    list:[]
}

const supportSlice=createSlice({
    name:"questions",
    initialState,
    reducers:{
        setQuestionList:(state,action)=>{
            state.list=action.payload
        }
    }
})

export const {setQuestionList}=supportSlice.actions

export const getQuestionsThunk=()=>{
    return async(dispatch)=>{
        try{
            let res=await hit("/interviews","get")
            if(!res.err){
                dispatch(setQuestionList(res?.data))
            }
        }catch(err){

        }finally{

        }
    }
}

export default supportSlice.reducer